import './Error.css';

export function Error (props) {
    return (
        <div className='error'>{ props.children }</div>
    )
}